import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styles/styled-components';

export interface SimpleNavDropdownItem {
  key: string;
  label: string;
  href: string;
  external?: boolean;
}

interface SimpleNavDropdownProps {
  items: SimpleNavDropdownItem[];
}

const Panel = styled.div`
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 110;
  padding-top: 5px;
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: max-content;
  min-width: 220px;
  padding: 4px;
  background: #ffffff;
  border: 1px solid #f2f3f5;
  border-radius: 12px;
  box-shadow: 2px 6px 32px 0px rgba(0, 0, 0, 0.1);
`;

const DropdownItem = styled.a`
  display: flex;
  align-items: center;
  height: 40px;
  padding: 12px 16px;
  border-radius: 8px;
  color: #303643;
  font-size: 14px;
  line-height: 22px;
  white-space: nowrap;
  text-decoration: none;
  &:hover {
    background: #f7f7f8;
    color: #303643;
  }
`;

const SimpleNavDropdown: FC<SimpleNavDropdownProps> = ({ items }) => (
  <Panel>
    <Card>
      {items.map((item) =>
        item.external ? (
          <DropdownItem key={item.key} href={item.href} target="_blank" rel="noopener noreferrer">
            {item.label}
          </DropdownItem>
        ) : (
          <DropdownItem key={item.key} as={Link} to={item.href}>
            {item.label}
          </DropdownItem>
        ),
      )}
    </Card>
  </Panel>
);

export default SimpleNavDropdown;
